var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test-result-circle-wrapper"},[_c('div',{staticClass:"test-result-circle",class:_vm.classType},[(_vm.show)?_c('span',{staticClass:"test-result-count"},[_vm._v(_vm._s(_vm.count))]):_vm._e()]),(_vm.show)?_c('b-icon',{staticClass:"circle-icon",attrs:{"icon":_vm.icon,"size":"is-small"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }